module.exports = __webpack_public_path__ + "img/Thumbnail_Mia_Chiara.eb62e712.png";